import {
  inject,
  Injectable,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  UserInformation,
  UserPreferences,
  UserSettings,
} from '../interfaces/interfaces';
import { ApiService } from '../services/api-services/api.service';
import { catchError, firstValueFrom, of, tap } from 'rxjs';
import { LanguageService } from '../services/languageservice/language.service';

@Injectable({
  providedIn: 'root',
})

export class UserStore {
  private _userSignal: WritableSignal<UserInformation> =
    signal<UserInformation>(null);
  private _userPreferencesSignal: WritableSignal<UserPreferences> =
    signal<UserPreferences>(null);

    
  public user: Signal<UserInformation> = this._userSignal.asReadonly();
  public userPreferences: Signal<UserPreferences> =
    this._userPreferencesSignal.asReadonly();

  private apiService: ApiService = inject(ApiService);
  private languageService: LanguageService = inject(LanguageService);
  constructor() {}

  public getUserInformation() {
    return firstValueFrom(
      this.apiService.getUserInformation().pipe(
        tap((user: UserInformation) => {
          console.log('user', user);
          this._userSignal.set(user);
          if (user.selectedLanguage) {
            this.languageService.resyncLanguage(user.selectedLanguage);
          }
        }),
        catchError((error) => {
          throw error;
        })
      )
    );
  }

  public getUserPreferences() {
    return firstValueFrom(
      this.apiService.getUserPreferences().pipe(
        tap((preferences: UserPreferences | null) => {
          if (!preferences?.userSettings) {
            if (preferences) {
              this._userPreferencesSignal.set(preferences);
            }
            return;
          }
          console.log('preferences', preferences);
          this._userPreferencesSignal.set(preferences);
        }),
        catchError((error) => {
          console.log('error', error);
          return of(null);
        })
      )
    );
  }

  public setUserPreferences(preferences: UserPreferences) {
    this._userPreferencesSignal.set(preferences);
  }

  public resetStoreData() {
    this._userSignal.set(null);
    this._userPreferencesSignal.set(null);
  }

  public updateUserSettings(settings: UserSettings) {
    return firstValueFrom(
      this.apiService.updateUserSettings(settings).pipe(
        tap(() => {
          this._userPreferencesSignal.update((prev) => ({
            ...prev,
            userSettings: settings,
          }));
        }),
        catchError((error) => {
          console.log('error', error);
          return of(null);
        })
      )
    );
  }

  public toggleMapFavorite(mapId: string) {
    return firstValueFrom(
      this.apiService.toggleMapFavorite(mapId).pipe(
        tap(() => {
          this._userPreferencesSignal.update((prev) => {
            if (prev.userFavoriteMaps.includes(mapId)) {
              return {
                ...prev,
                userFavoriteMaps: prev.userFavoriteMaps.filter(
                  (id) => id !== mapId
                ),
              };
            } else {
              return {
                ...prev,
                userFavoriteMaps: [...prev.userFavoriteMaps, mapId],
              };
            }
          });
        }),
        catchError((error) => {
          console.log('error', error);
          return of(null);
        })
      )
    );
  }
}
